import React, { useId } from 'react'
import { SuperGrain } from '../SuperGrain'

export const BlueSphereRightTop = ({
  hideGrain,
  svgProps,
}: {
  hideGrain?: boolean
  svgProps: React.SVGProps<SVGSVGElement>
}) => {
  const uniqueId = useId()
  const maskId = `grainFilter-blue-sphere-right-top-${uniqueId}`

  return (
    <svg
      {...svgProps}
      viewBox="0 0 717 558"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4716_2081)">
        <path
          data-figma-bg-blur-radius="5.57479"
          d="M1173.55 1274.76L1260.13 1285.86L2116.18 1072.56L1173.55 1137.12L1037.14 1170.35L860.545 1274.76L1173.55 1274.76Z"
          fill="url(#paint0_linear_4716_2081)"
          fillOpacity="0.01"
        />
        <g filter="url(#filter1_f_4716_2081)">
          <ellipse
            cx="1225.71"
            cy="449.706"
            rx="1215.71"
            ry="449.706"
            transform="matrix(-0.999999 -2.07407e-07 3.86216e-06 -1 2559.27 596.492)"
            fill="url(#paint1_radial_4716_2081)"
          />
        </g>
        <g filter="url(#filter2_f_4716_2081)">
          <ellipse
            cx="1135.77"
            cy="381.426"
            rx="1135.77"
            ry="381.426"
            transform="matrix(-0.999999 -2.07407e-07 3.86216e-06 -1 2469.33 507.266)"
            fill="url(#paint2_radial_4716_2081)"
          />
        </g>
        <g filter="url(#filter3_f_4716_2081)">
          <ellipse
            cx="1075.1"
            cy="400.437"
            rx="1075.1"
            ry="400.437"
            transform="matrix(-0.999999 -2.07407e-07 3.86216e-06 -1 2408.67 484.668)"
            fill="url(#paint3_radial_4716_2081)"
          />
        </g>
        <g filter="url(#filter4_d_4716_2081)">
          <ellipse
            cx="917.318"
            cy="283.657"
            rx="917.318"
            ry="283.657"
            transform="matrix(-0.999999 0.000709021 -0.00510843 -0.999987 2252.33 390.643)"
            fill="url(#paint4_radial_4716_2081)"
          />
        </g>
        <g filter="url(#filter5_f_4716_2081)">
          <path
            d="M1335.37 471.866C1029.79 472.082 752.958 432.954 552.402 369.524C452.122 337.809 370.927 300.023 314.746 258.052C258.56 216.078 227.434 169.953 227.187 121.563C226.94 73.1721 257.594 27.0035 313.351 -15.0499C369.103 -57.0997 449.911 -95.0009 549.866 -126.858C749.773 -190.572 1026.21 -230.092 1331.78 -230.309C1637.35 -230.526 1914.19 -191.397 2114.74 -127.968C2215.02 -96.2524 2296.22 -58.4661 2352.4 -16.4956C2408.59 25.4784 2439.71 71.6032 2439.96 119.994C2440.21 168.384 2409.55 214.553 2353.8 256.606C2298.04 298.656 2217.24 336.557 2117.28 368.415C1917.37 432.128 1640.94 471.649 1335.37 471.866Z"
            stroke="white"
            strokeWidth="0.525556"
          />
        </g>
        <g>
          <g filter="url(#filter6_f_4716_2081)">
            <circle
              cx="6.53295"
              cy="6.53295"
              r="6.53295"
              transform="matrix(-1 0 0 1 239.606 77.6963)"
              fill="white"
            />
          </g>
          <g filter="url(#filter7_f_4716_2081)">
            <circle
              cx="14.5104"
              cy="14.5104"
              r="14.5104"
              transform="matrix(-1 0 0 1 254.117 158.586)"
              fill="white"
            />
          </g>
          <g filter="url(#filter8_f_4716_2081)">
            <circle
              cx="12.2516"
              cy="12.2516"
              r="12.2516"
              transform="matrix(-1 0 0 1 251.866 160.845)"
              fill="#439BED"
            />
          </g>
        </g>
        <g filter="url(#filter9_f_4716_2081)">
          <path
            d="M29.3604 364.368L787.656 364.368L1545.95 364.368V187.606L29.3604 187.606L29.3604 364.368Z"
            fill="url(#paint5_linear_4716_2081)"
            fillOpacity="0.01"
          />
        </g>
      </g>
      <defs>
        <clipPath
          id="bgblur_1_4716_2081_clip_path"
          transform="translate(-860.545 -1072.56)"
        >
          <path d="M1173.55 1274.76L1260.13 1285.86L2116.18 1072.56L1173.55 1137.12L1037.14 1170.35L860.545 1274.76L1173.55 1274.76Z" />
        </clipPath>
        <filter
          id="filter1_f_4716_2081"
          x="83.6196"
          y="-327.168"
          width="2499.9"
          height="947.906"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="12.1231"
            result="effect1_foregroundBlur_4716_2081"
          />
        </filter>
        <filter
          id="filter2_f_4716_2081"
          x="167.047"
          y="-286.343"
          width="2333.05"
          height="824.365"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="15.3782"
            result="effect1_foregroundBlur_4716_2081"
          />
        </filter>
        <filter
          id="filter3_f_4716_2081"
          x="191.556"
          y="-383.13"
          width="2284.04"
          height="934.721"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="33.4616"
            result="effect1_foregroundBlur_4716_2081"
          />
        </filter>
        <filter
          id="filter4_d_4716_2081"
          x="375.089"
          y="-233.632"
          width="1916.95"
          height="649.619"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-16.4623" />
          <feGaussianBlur stdDeviation="20.5779" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4716_2081"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4716_2081"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_f_4716_2081"
          x="226.046"
          y="-231.448"
          width="2215.05"
          height="704.454"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.437963"
            result="effect1_foregroundBlur_4716_2081"
          />
        </filter>
        <filter
          id="filter6_f_4716_2081"
          x="224.789"
          y="75.9444"
          width="16.5696"
          height="16.5696"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.875926"
            result="effect1_foregroundBlur_4716_2081"
          />
        </filter>
        <filter
          id="filter7_f_4716_2081"
          x="223.345"
          y="156.834"
          width="32.5245"
          height="32.5245"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.875926"
            result="effect1_foregroundBlur_4716_2081"
          />
        </filter>
        <filter
          id="filter8_f_4716_2081"
          x="224.735"
          y="158.217"
          width="29.7588"
          height="29.7587"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.31389"
            result="effect1_foregroundBlur_4716_2081"
          />
        </filter>
        <filter
          id="filter9_f_4716_2081"
          x="-117.269"
          y="40.9766"
          width="1809.85"
          height="470.021"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="73.3149"
            result="effect1_foregroundBlur_4716_2081"
          />
        </filter>
        <clipPath
          id="bgblur_2_4716_2081_clip_path"
          transform="translate(117.269 -40.9766)"
        >
          <path d="M29.3604 364.368L787.656 364.368L1545.95 364.368V187.606L29.3604 187.606L29.3604 364.368Z" />
        </clipPath>
        <linearGradient
          id="paint0_linear_4716_2081"
          x1="1467.42"
          y1="1439.5"
          x2="1368.54"
          y2="1330.61"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_4716_2081"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1225.7 259.133) rotate(89.9997) scale(869.284 2369.29)"
        >
          <stop offset="0.305" stopColor="#176AE5" />
          <stop offset="0.744002" stopColor="white" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_4716_2081"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1135.76 219.788) rotate(89.9996) scale(737.298 2195.44)"
        >
          <stop offset="0.4" stopColor="#83D4FF" />
          <stop offset="0.629788" stopColor="#EEBACB" />
          <stop offset="0.744002" stopColor="white" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_4716_2081"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1075.09 230.743) rotate(89.9997) scale(774.047 2078.17)"
        >
          <stop offset="0.305" stopColor="#ECB9CB" />
          <stop offset="0.629788" stopColor="#EEBACB" />
          <stop offset="0.744002" stopColor="white" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_4716_2081"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(917.549 246.144) rotate(90.0412) scale(321.169 1038.63)"
        >
          <stop offset="0.205439" stopColor="#2877E7" />
          <stop offset="0.674426" stopColor="#75A8F0" />
          <stop offset="0.843487" stopColor="#B1CEF6" />
          <stop offset="0.93127" stopColor="#C9DDF9" />
          <stop offset="1" stopColor="white" />
        </radialGradient>
        <linearGradient
          id="paint5_linear_4716_2081"
          x1="959.737"
          y1="522.676"
          x2="959.737"
          y2="427.763"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
        <clipPath id="clip0_4716_2081">
          <rect width="717" height="558" fill="white" />
        </clipPath>
        <mask id={maskId}>
          <rect width="100%" height="100%" fill="black" />
          <g filter="url(#filter1_f_4716_2081)">
            <ellipse
              cx="1225.71"
              cy="449.706"
              rx="1225.71"
              ry="449.706"
              transform="matrix(-0.999999 -2.07407e-07 3.86216e-06 -1 2559.27 596.492)"
              fill="white"
            />
          </g>
          <g filter="url(#filter2_f_4716_2081)">
            <ellipse
              cx="1135.77"
              cy="381.426"
              rx="1135.77"
              ry="381.426"
              transform="matrix(-0.999999 -2.07407e-07 3.86216e-06 -1 2469.33 507.266)"
              fill="white"
            />
          </g>
          <g filter="url(#filter3_f_4716_2081)">
            <ellipse
              cx="1075.1"
              cy="400.437"
              rx="1075.1"
              ry="400.437"
              transform="matrix(-0.999999 -2.07407e-07 3.86216e-06 -1 2408.67 484.668)"
              fill="white"
            />
          </g>
          <g filter="url(#filter4_d_4716_2081)">
            <ellipse
              cx="917.318"
              cy="283.657"
              rx="917.318"
              ry="283.657"
              transform="matrix(-0.999999 0.000709021 -0.00510843 -0.999987 2252.33 390.643)"
              fill="white"
            />
          </g>
          <g filter="url(#filter6_f_4716_2081)">
            <circle
              cx="6.53295"
              cy="6.53295"
              r="6.53295"
              transform="matrix(-1 0 0 1 239.606 77.6963)"
              fill="white"
            />
          </g>
          <g filter="url(#filter7_f_4716_2081)">
            <circle
              cx="14.5104"
              cy="14.5104"
              r="14.5104"
              transform="matrix(-1 0 0 1 254.117 158.586)"
              fill="white"
            />
          </g>
          <g filter="url(#filter8_f_4716_2081)">
            <circle
              cx="12.2516"
              cy="12.2516"
              r="12.2516"
              transform="matrix(-1 0 0 1 251.866 160.845)"
              fill="white"
            />
          </g>
        </mask>
      </defs>
      {!hideGrain && (
        <foreignObject
          x="0"
          y="0"
          width="100%"
          height="100%"
          mask={`url(#${maskId})`}
        >
          <SuperGrain zIndex={0} />
        </foreignObject>
      )}
    </svg>
  )
}
